<template>
    <div class="carBox" @mouseup="handleMouseUp">
        <el-card ref="left_tree" class="box-card" style="height: calc(100vh - 152px);width: 280px;overflow-y: auto">
            <el-tree :data="projectDivisionData" node-key="value" :current-node-key="pid" :highlight-current="true" ref="my-tree" @node-click="clickPrjectDivision" :default-expanded-keys="openKeys" :expand-on-click-node="false">
                <span slot-scope="{ node }" class="custom-tree-node treeTitle" :title="node.label.split('###')[3]">
                    {{node.label.split('###')[0]}}
                    <span :class="'treeTitleNum'+node.label.split('###')[1]">{{node.label.split('###')[2]}}</span>
                </span>
            </el-tree>
        </el-card>
        <div ref="resizeHandle" class="handle-resize" />
        <div ref="moveDiv" class="handle-resize-h" />
        <el-card ref="right_content" class="box-card" style="width: calc(100% - 290px);">
            <div class="mainBody">
                <div class="searchBox">
                    <div class="searchGroup">
                        <label>名称：</label>
                        <el-input v-model="search_Obj.f_title" clearable @keyup.enter.native="doSearch"></el-input>
                    </div>
                    <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
                    <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick" v-if="pid>0"></Btns>
                    <Btns :menu_id="menu_id" :menus="main_btns" :ignore_ids="',8201,'" @on_btnclk="btnClick" v-else></Btns>
                </div>
                <div class="dataBox">
                    <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                        <el-table-column type="selection" align="center" width="50"></el-table-column>
                        <el-table-column prop="title" label="标题" sortable="custom"></el-table-column>
                        <el-table-column prop="file_name" label="文件名称" sortable="custom"></el-table-column>
                        <el-table-column prop="file_size" label="文件大小" sortable="custom"></el-table-column>
                        <el-table-column prop="add_time" label="添加时间" sortable="custom"></el-table-column>
                        <el-table-column label="操作" width="220" align="center">
                            <template slot-scope="scope">
                                <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pageBox">
                    <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50]" :current-page="current" :page-size="pagesize" :total="total" @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
                </div>
                <Edit
                    width="600px"
                    :id="model_id"
                    :title="edit_title"
                    :isshow="editshow"
                    :pid="pid"
                    @on-close="closeEditDialog"
                    @on-save-ok="saveOk">
                </Edit>
                <Info
                    width="600px"
                    :id="model_id"
                    title="查看物探成果"
                    :isshow="infoshow"
                    @on-close="closeInfoDialog">
                </Info>
                <Video
                    width="900px"
                    title="预览视频"
                    :videoUrl="videoUrl"
                    :isshow="videoshow"
                    @on-close="closeVideoDialog">
                </Video>
                <Word
                    width="900px"
                    title="预览文档"
                    :docUrl="docUrl"
                    :isshow="docshow"
                    @on-close="closeDocDialog">
                </Word>
                <Excel
                    width="900px"
                    title="预览文档"
                    :xlsUrl="xlsUrl"
                    :isshow="xlsshow"
                    @on-close="closeXlsDialog">
                </Excel>
                <SelType
                    width="600px"
                    title="选择文件类型"
                    :isshow="seltypeshow"
                    @on-close="closeSelTypeDialog"
                    @on-save-ok="selTypeOk">
                </SelType>
            </div>
        </el-card>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import Edit from "./edit"
import Info from "./info"
import Video from "../wtcg/video.vue"
import Word from "../wtcg/word.vue"
import Excel from "../wtcg/excel.vue"
import SelType from "../wtcg/selfiletype.vue"
import listutil from "@/libs/listutil"
import { getProjectDivisionTreeData } from '@/api/org'
import { downDesignDrawings } from '@/api/annex'

export default {
    name: 'designDrawingsList',
    mixins: [listutil],
    components: {Edit, Info, Video, Word, Excel, SelType, Btns, LabBtns},
    data() {
        return {
            m_name: '设计图纸',
            menu_id: 8200,
            list_url: "/api/admin/designdrawings/list",
            search_Obj: {
                f_title: '',
            },
            del_Obj:{
                url:'/api/admin/designdrawings/del',
                data:{
                    ids:''
                }
            },
            enu_name: [],
            grade: 1,
            pid: 0,
            projectDivisionData: [],
            openKeys: [],
            videoshow: false,
            videoUrl: '',
            docshow: false,
            docUrl: '',
            xlsshow: false,
            xlsUrl: '',
            seltypeshow: false,
            ben: 1,
        };
    },
    mounted(){
        this.dragControllerDiv(this.$refs.left_tree.$el, this.$refs.resizeHandle, this.$refs.moveDiv)
    },
    methods: {
        loadOtherData() {
            this.initTree()
        },
        initTree(){
            this.projectDivisionData = []
            getProjectDivisionTreeData(52).then(res=>{
                if(res.code ==1){
                    var treeData = res.data
                    treeData = this.removeEmptyChild(treeData)
                    this.projectDivisionData = treeData
                    this.initOpenKeys()
                }
            })
        },
        initOpenKeys(){//哪些节点要展开
            this.openKeys = this.getAllNodeId(this.openKeys, this.projectDivisionData, 0)
        },
        getAllNodeId (expandedKeys, moduleDataList, level) {
            if(level>1){
                return expandedKeys
            }
            for (let i = 0; i < moduleDataList.length; i++) {
                expandedKeys.push(moduleDataList[i].value)
                if (moduleDataList[i].children) {
                    expandedKeys = this.getAllNodeId(expandedKeys, moduleDataList[i].children, level+1)
                }
            }
            return expandedKeys
        },
        clickPrjectDivision(data){
            this.pid = data.id
            this.search_Obj.pid = data.id
            this.current = 1
            this.getListData()
        },
        preview(index, row){
            if(row.suffix == ".XLSX" || row.suffix == ".XLS"){
                this.xlsshow = true
                this.xlsUrl = row.file_path
            }else if(row.suffix == ".DOCX" || row.suffix == ".DOC"){
                this.docshow = true
                this.docUrl = row.file_path
            }else if(row.suffix == ".JPG" || row.suffix == ".PNG" || row.suffix == ".PDF"){
                window.open(row.file_path)
            }else if(row.suffix == ".MP4"){
                this.videoshow = true
                this.videoUrl = row.file_path
            }else{
                this.$msg("该附件格式无法预览")
            }
        },
        download(index, row){
            window.open(row.file_path)
        },
        closeVideoDialog(){
            this.videoshow = false
        },
        closeDocDialog(){
            this.docshow = false
        },
        closeXlsDialog(){
            this.xlsshow = false
        },
        downloadAll(){
            this.ben = 1;
            this.seltypeshow = true
        },
        downloadAll1(){
            this.ben = 0;
            this.seltypeshow = true
        },
        selTypeOk(p){
            this.seltypeshow = false
            downDesignDrawings(this.pid, this.ben, p.file_type).then(res=>{
                if(res.code == 1){
                    window.open(res.data)
                }else{
                    this.$msg(res.msg)
                }
            })
        },
        closeSelTypeDialog(){
            this.seltypeshow = false
        }
    }
};
</script>